import { NextPage } from 'next'

import useRecipes from '../hooks/useRecipes'
import DefaultLayout from '../layout/DefaultLayout'
import RecipesTemplate from '../templates/Recipes'
import RecipesSagas from '../redux/recipes/sagas'

const Recipes: NextPage = () => {
  const { recipesTemplateProps } = useRecipes()

  return (
    <DefaultLayout seoProps={recipesTemplateProps?.seoProps}>
      <RecipesTemplate {...recipesTemplateProps} />
    </DefaultLayout>
  )
}

Recipes.getInitialProps = async (ctx: any) =>
  ctx.store.saga.run(RecipesSagas.init, ctx).toPromise()

export default Recipes
